/* eslint-disable prettier/prettier */
/* eslint-disable max-len */

/*
 * Copyright (c) 2023, WSO2 LLC. (http://www.wso2.com). All Rights Reserved.
 *
 * This software is the property of WSO2 LLC. and its suppliers, if any.
 * Dissemination of any information or reproduction of any material contained
 * herein is strictly forbidden, unless permitted by WSO2 in accordance with
 * the WSO2 Commercial License available at http://wso2.com/licenses.
 * For specific language governing the permissions and limitations under
 * this license, please see the license as well as any agreement you’ve
 * entered into with WSO2 governing the purchase of this software and any
 * associated services.
 */

import { createSvgIcon } from '@material-ui/core';
import * as React from 'react';

export default createSvgIcon(
  <path
    fill="currentColor"
    fillRule="evenodd"
    d="M6.1508.8787A3 3 0 0 1 8.272 0h7.4558c.7957 0 1.5587.316 2.1213.8787l5.2721 5.272A3 3 0 0 1 24 8.2722v7.4558a3 3 0 0 1-.8787 2.1213l-5.2721 5.2721A3 3 0 0 1 15.7279 24H8.2721a3 3 0 0 1-2.1213-.8787L.8787 17.8492A2.9998 2.9998 0 0 1 0 15.7279V8.2721a3 3 0 0 1 .8787-2.1213L6.1507.8787ZM12.5 8.5c0 2.2091-1.7909 4-4 4-2.2091 0-4-1.7909-4-4 0-2.2091 1.7909-4 4-4 2.2091 0 4 1.7909 4 4Zm3 11c2.2091 0 4-1.7909 4-4 0-2.2091-1.7909-4-4-4-2.2091 0-4 1.7909-4 4 0 2.2091 1.7909 4 4 4Z"
    clipRule="evenodd"
  />,
  'CellDiagramFilled'
);
